// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2uHXY","buttons":"PendingPaymentAlert_buttons__DyzA3"};